"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdSuccessPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AdSuccessPanel, _Component);

  function AdSuccessPanel() {
    (0, _classCallCheck3.default)(this, AdSuccessPanel);
    return (0, _possibleConstructorReturn3.default)(this, (AdSuccessPanel.__proto__ || (0, _getPrototypeOf2.default)(AdSuccessPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(AdSuccessPanel, [{
    key: "render",
    value: function render() {
      var ad = this.props.ad;

      var isProjectAd = false;
      if (ad) {
        if (ad.project_id > 0) {
          isProjectAd = true;
          return _react2.default.createElement(
            "div",
            { className: "col col-xs-12 text-center" },
            _react2.default.createElement("i", { className: "icon-mp-ok create-ad-success-icon" }),
            _react2.default.createElement(
              "div",
              { className: "col-xs-8 col-xs-offset-2" },
              _react2.default.createElement(
                "h1",
                { className: "h3 title-js" },
                this.renderTitleText()
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col-xs-12" },
              _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                  "p",
                  null,
                  _react2.default.createElement("br", null),
                  _react2.default.createElement("br", null)
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col col-sm-6" },
                  _react2.default.createElement(_Button2.default, {
                    text: "Projektiin",
                    additionalClasses: "button-set-width button-inverse",
                    onClick: this.handleProjectButtonClick.bind(this)
                  })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col col-sm-6" },
                  _react2.default.createElement(_Button2.default, {
                    text: "Uusi ilmoitus",
                    additionalClasses: "button-set-width button-inverse",
                    onClick: this.handleNewProjectAdButtonClick.bind(this)
                  })
                )
              )
            )
          );
        }
      }

      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 text-center" },
        _react2.default.createElement("i", { className: "icon-mp-ok create-ad-success-icon" }),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-xs-offset-2" },
          _react2.default.createElement(
            "h1",
            { className: "h3 title-js" },
            this.renderTitleText()
          )
        ),
        this.renderTransferRequestText(),
        _react2.default.createElement(
          "div",
          { className: "col-xs-12" },
          this.renderLogInText(),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null)
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6" },
              _react2.default.createElement(_Button2.default, {
                text: "Hakutuloksiin",
                additionalClasses: "button-set-width button-inverse",
                onClick: this.handleSearchButtonClick.bind(this)
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6" },
              _react2.default.createElement(_Button2.default, {
                text: "Uusi ilmoitus",
                additionalClasses: "button-set-width button-inverse",
                onClick: this.handleNewAdButtonClick.bind(this)
              })
            )
          )
        )
      );
    }
  }, {
    key: "renderTitleText",
    value: function renderTitleText() {
      return this.props.editing ? "Ilmoituksen päivittäminen onnistui!" : "Ilmoituksen lisääminen onnistui!";
    }
  }, {
    key: "renderLogInText",
    value: function renderLogInText() {
      var user = this.props.user;

      if (user) {
        return null;
      } else {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-12 text-center" },
            _react2.default.createElement(_Button2.default, {
              text: "Tilaa profiili",
              additionalClasses: "button-set-width",
              onClick: this.handleRegisterButtonClick.bind(this)
            }),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                { id: "gtm_new_ad" },
                " ",
                "Tilaamalla profiilin saat enemm\xE4n. Klikkaa \u201DTilaa profiili\u201D ja lue lis\xE4\xE4."
              )
            )
          )
        );
      }
    }
  }, {
    key: "handleSearchButtonClick",
    value: function handleSearchButtonClick() {
      this.props.resetState();
      if (this.props.supplierAd) {
        this.props.pushRoute("/ilmoitukset/vastaanotettavat");
      } else {
        this.props.pushRoute("/ilmoitukset/tarjottavat");
      }
    }
  }, {
    key: "handleRegisterButtonClick",
    value: function handleRegisterButtonClick() {
      this.props.pushRoute("/rekisteroidy");
    }
  }, {
    key: "handleNewAdButtonClick",
    value: function handleNewAdButtonClick() {
      this.props.resetState();
    }
  }, {
    key: "handleProjectButtonClick",
    value: function handleProjectButtonClick() {
      this.props.resetState();
      var ad = this.props.ad;

      this.props.pushRoute("/projekti/" + ad.project_id);
    }
  }, {
    key: "handleNewProjectAdButtonClick",
    value: function handleNewProjectAdButtonClick() {
      this.props.resetState();
      var ad = this.props.ad;

      this.props.pushRoute("/jata-ilmoitus/projekti/" + ad.project_id);
    }
  }, {
    key: "renderTransferRequestText",
    value: function renderTransferRequestText() {
      if (this.props.transferRequestSent && !this.props.editing) {
        return _react2.default.createElement(
          "div",
          { className: "col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "transfer-request-sent-js" },
            "Kuljetustarjouspyynt\xF6 l\xE4hetetty."
          )
        );
      }
    }
  }]);
  return AdSuccessPanel;
}(_react.Component), _class.propTypes = {
  transferRequestSent: _react.PropTypes.bool,
  editing: _react.PropTypes.bool.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  resetState: _react.PropTypes.func.isRequired,
  supplierAd: _react.PropTypes.bool.isRequired,
  user: _react.PropTypes.object,
  ad: _react.PropTypes.object
}, _temp);
exports.default = AdSuccessPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/AdSuccessPanel.js
 ** module id = 476
 ** module chunks = 0
 **/